import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { httpinstance, httpinstancefile } from "../../axios/api";

export const getallairports = createAsyncThunk("getallairports", async () => {
  try {
    const url = "airports";
    const response = await httpinstance.get(url);
    return response;
  } catch (err) {
    return err.response;
  }
});
export const getOriginAirports = createAsyncThunk("getOriginAirports", async () => {
  try {
    const url = "origin_airports";
    const response = await httpinstance.get(url);
    return response;
  } catch (err) {
    return err.response;
  }
});
export const getallshipments = createAsyncThunk("getallshipments", async () => {
  try {
    const url = "list_ocean_port";
    const response = await httpinstance.get(url);
    return response;
  } catch (err) {
    return err.response;
  }
});
// Reference-data lookups for the Ocean search form's Charges & Terms /
// Service Provider sections. Each returns a list of { _id, ... } used to
// populate the currency / platform / online dropdowns (stored in state below).
export const getCurrencyList = createAsyncThunk("getCurrencyList", async () => {
  try {
    const url = "general/currency";
    const response = await httpinstance.get(url);
    return response;
  } catch (err) {
    return err.response;
  }
});
export const getPlatformList = createAsyncThunk("getPlatformList", async () => {
  try {
    const url = "general/platform";
    const response = await httpinstance.get(url);
    return response;
  } catch (err) {
    return err.response;
  }
});
export const getOnlineList = createAsyncThunk("getOnlineList", async () => {
  try {
    const url = "general/online";
    const response = await httpinstance.get(url);
    return response;
  } catch (err) {
    return err.response;
  }
});
// Ocean shipping lines set up in admin Carrier Management (Ocean tab), each
// with its status / auto_search / auto_book flags.
export const getAllowedShippingLines = createAsyncThunk("getAllowedShippingLines", async () => {
  try {
    const url = "allowed-shippingline";
    const response = await httpinstance.get(url);
    return response;
  } catch (err) {
    return err.response;
  }
});
export const searchrates = createAsyncThunk(
  "searchrates",
  async (values, { getState, rejectWithValue }) => {
    try {
      const payloadData = JSON.parse(JSON.stringify(values));
      delete payloadData.searchquery;
      delete payloadData.destinationcityName;
      delete payloadData.destinationcountryName;
      delete payloadData.origincityName;
      delete payloadData.origincountryName;
      const bodyParams = {
        airlinepayloadData: payloadData,
        ...values.searchquery,
      };
      const responseCargoRes = await httpinstance.post(
        "search_cargo_result",
        bodyParams
      );
      let payloadResponse = { ...responseCargoRes };
      // console.log(payloadResponse,payloadResponse?.data,payloadResponse?.data?.nodeData,"payloadResponse");
      delete values.searchquery;
      // let data=responseCargoRes?.data
      // let data2=responseCargoRes?.data?.nodeData
      // let finaldata=structuredClone(responseCargoRes?.data?.nodeData)
      // let data3=values
      // console.log(data,data2,data3,"data");
      let payloadResponse1 = {
        ...payloadResponse.data,
        // ...responseCargoRes?.data,
        // data,
        nodeData: {
          ...payloadResponse?.data?.nodeData,

          // bookingId: "hi",
          // ...responseCargoRes?.data?.nodeData,
          // finaldata
          // ,...data3
          //...values,
          ...values,
          bookingId: payloadResponse?.data?.nodeData?.bookingId,
        },
      };

      return payloadResponse1;
    } catch (err) {
      return rejectWithValue(err?.response?.data) 
    }
  }
);



export const searchratefileup = createAsyncThunk(
  "searchratefileup",
  async (values) => {
    try {
      const url = "fileupload";
      const response = await httpinstancefile.post(url, values);
      return response;
    } catch (err) {
      return err.response;
    }
  }
);

export const searchOceanRate = createAsyncThunk(
  "searchOceanRate",
  async (values) => {
    try {
      const url = "ratesearch/all-ocean-rates";
      const response = await httpinstance.post(url, values);
      return response;
    } catch (err) {
      return err.response;
    }
  }
);
// Fetch a previously-saved ocean query/booking by its queryId (the `?_id=` URL
// param used to deep-link into /search-rates). The response's `data.searchquery`
// has the same shape as a submitted ocean query and is fed back into the search
// form to auto-populate every field.
export const getSingleBookingData = createAsyncThunk(
  "getSingleBookingData",
  async (queryId) => {
    try {
      const url = "single_booking_data";
      const response = await httpinstance.post(url, { queryId });
      return response;
    } catch (err) {
      return err.response;
    }
  }
);
// Fetch the raw saved Query document by its queryId. Used when editing a
// still-quote-stage query (Quote Pending / Auto Quoted) from the Queries page,
// where we want the original query — not booking data. Response is the standard
// ApiResponse envelope: { statusCode, data: <full Query document>, message }.
export const getQuery = createAsyncThunk(
  "getQuery",
  async (arg) => {
    try {
      // Accept a bare id or { queryId } so either call style works.
      const queryId = typeof arg === "string" ? arg : arg?.queryId;
      const url = "ratesearch/get-query";
      const response = await httpinstance.post(url, { queryId });
      return response;
    } catch (err) {
      return err.response;
    }
  }
);
export const createOceanBooking = createAsyncThunk(
  "createOceanBooking",
  async (values) => {
    try {
      const url = "ratesearch/create-ocean-booking";
      const response = await httpinstance.post(url, values);
      return response;
    } catch (err) {
      return err.response;
    }
  }
);
// Ocean analogue of the air-cargo booking update (see airlineairportslice
// `bookingupdate`). Called when re-quoting an already-booked ocean query:
// persists the new offer/schedule against the existing queryId instead of
// creating a fresh booking. Endpoint name mirrors create-ocean-booking; adjust
// if the backend exposes a different path.
export const updateOceanBooking = createAsyncThunk(
  "updateOceanBooking",
  async (values) => {
    try {
      const url = "ratesearch/update-ocean-booking";
      const response = await httpinstance.post(url, values);
      return response;
    } catch (err) {
      return err.response;
    }
  }
);

// Dedicated KAM ocean-booking endpoints (kam role only, enforced server-side by
// checkKam(["kam"])) — a KAM books a customer's auto-quoted shipment directly,
// with no online payment collection, landing on "Confirmation Awaited" until
// the MBL is assigned via confirmKamOceanBooking below.
export const createKamOceanBooking = createAsyncThunk(
  "createKamOceanBooking",
  async (values) => {
    try {
      const url = "kam/ocean-booking";
      const response = await httpinstance.post(url, values);
      return response;
    } catch (err) {
      return err.response;
    }
  }
);

export const confirmKamOceanBooking = createAsyncThunk(
  "confirmKamOceanBooking",
  async (values) => {
    try {
      const url = "kam/ocean-booking/confirm";
      const response = await httpinstance.post(url, values);
      return response;
    } catch (err) {
      return err.response;
    }
  }
);

// Edit of the "Bill of Lading Details" grid on an already-confirmed ocean
// booking (the Documents popup on the Queries page). The whole array goes back
// — the backend replaces the stored list on both the payment and the query
// record — so edits to existing rows and rows added via "Add BL No" travel in
// the same call.
export const updateOceanBlDetails = createAsyncThunk(
  "updateOceanBlDetails",
  async (values) => {
    try {
      const url = "kam/ocean-booking/bl-details";
      const response = await httpinstance.put(url, values);
      return response;
    } catch (err) {
      return err.response;
    }
  }
);

export const loctionFromfreightify = createAsyncThunk(
  "loctionFromfreightify",
  async ({ searchText, countryCode, mode }) => {
    try {
      const url = `ratesearch/freightify-locations-api?searchText=${encodeURIComponent(
        searchText
      )}&countryCode=${countryCode}&mode=${mode}`;

      const response = await httpinstance.get(url);
      return response;
    } catch (err) {
      return err.response;
    }
  }
);

export const checkblackedlist = createAsyncThunk(
  "checkblackedlist",
  async (values) => {
    try {
      const url = "checkblacklist";
      const response = await httpinstance.post(url, values);
      return response;
    } catch (err) {
      return err.response;
    }
  }
);

export const viewBreakUp = createAsyncThunk("view-break-up", async (values) => {
  try {
    const url =  !values?.queryid ? `view-break-up` : `view-break-up/${values?.queryid}` ;
    const response = await httpinstance.post(url , values);
    return response;
  } catch (err) {
    throw  err
  }
});
//POST - {{local}}/api/airVas/rate/getOptionalVas

export const getOptionalVas = createAsyncThunk("getOptionalVas", async (values) => {
  try {
    const url =  `airVas/rate/getOptionalVas` ;
    const response = await httpinstance.post(url , values);
    return response;
  } catch (err) {
    throw  err
  }
});

const initialState = {
  data: {},
  loading: false,
  allairports: [],
  originairports: {},
  allshipports: {},
  viewBreakUp : {},
  isbookingsucess: false,
  optionalvas : {},
  searchRateAnimationPayloadData : {},
  searchratesAvailableData: {},
  currencyList: [],
  platformList: [],
  onlineList: [],
  allowedShippingLines: [],
  // Ocean rate search: own loading flag (so the search form's <Spin> — keyed on
  // `loading` — never shows) + the result delivered to the results page.
  oceanLoading: false,
  oceanRates: null,
  // True while re-quoting an ALREADY-CONFIRMED booking (deep-linked via
  // /search-rates?_id=). Locks the top nav (except "Search Rates") and the
  // mode tabs so the user can't wander off mid-update; cleared on any reset.
  oceanEditLocked: false
};

const searchRatesSlice = createSlice({
  name: "searchrates",
  initialState,
  reducers: {
    clearstate: (state) => {
      state.data = {};
      state.isbookingsucess = true;
      state.oceanEditLocked = false;
    },
    searchRateAnimation : (state , actions)=>{
      state.searchRateAnimationPayloadData = actions.payload;
    },
    clearSearchRateAvailableData : (state , actions)=> {   
      state.searchratesAvailableData = {};   
      // if (state.searchratesAvailableData?.nodeData?.airlineResponse) {
      //   state.searchratesAvailableData.nodeData.airlineResponse = [];
      // }
    },
    setsearchratesAvailableData : (state , actions)=>{
      // console.log(actions.payload,"actions.payload");
      state.searchratesAvailableData =  actions.payload
    },
    // Store the previous ocean query so the search form can prefill on "Edit
    // Query" (the ocean search thunk doesn't populate `data` the way the air
    // search does). Shape mirrors what NewSearchRates / ShipmentRateForm read:
    // data.data.nodeData.searchquery for the form, data.nodeData.searchquery
    // for the tab-selection effect.
    setOceanEditQuery: (state, actions) => {
      state.data = actions.payload;
    },
    // Clear the persisted ocean search/query redux after a booking is confirmed
    // so a fresh search starts clean — no Edit-Query prefill (`data`) and no
    // stale results (`oceanRates`) leaking into the next search. Idempotent and
    // safe to call even if these were never set. Only touches ocean-relevant
    // fields; air lookup lists (currency/platform/online, allairports, etc.)
    // are left untouched.
    clearOceanSearchForm: (state) => {
      state.data = {};
      state.oceanRates = null;
      state.oceanLoading = false;
      state.oceanEditLocked = false;
    },
    // Toggle the confirmed-booking edit lock (see oceanEditLocked in state).
    // Set true by NewSearchRates once a confirmed booking loads for re-quote,
    // false when the deep-link is absent / the booking isn't confirmed.
    setOceanEditLock: (state, actions) => {
      state.oceanEditLocked = !!actions.payload;
    },
     resetSearchRatesState: () => initialState,
  },
 
  extraReducers: (builder) => {
    builder.addCase(searchrates.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(searchrates.fulfilled, (state, { payload }) => {
      return { ...state, loading: false, data: payload };
    });
    builder.addCase(searchrates.rejected, (state, { payload }) => {
      return { ...state, loading: false, data: payload };
    });
    // Ocean search uses its OWN `oceanLoading` (NOT `loading`) so the search
    // FORM never shows its <Spin>; the form navigates immediately and only the
    // RESULTS page reads `oceanLoading` for its listing skeleton. The result is
    // stored in `oceanRates` ({status, data}); `data` stays reserved for the
    // Edit Query prefill payload.
    builder.addCase(searchOceanRate.pending, (state) => {
      return { ...state, oceanLoading: true, oceanRates: null };
    });
    builder.addCase(searchOceanRate.fulfilled, (state, { payload }) => {
      return {
        ...state,
        oceanLoading: false,
        oceanRates: { status: payload?.status, data: payload?.data },
      };
    });
    builder.addCase(searchOceanRate.rejected, (state, { payload }) => {
      return {
        ...state,
        oceanLoading: false,
        oceanRates: { status: payload?.status, data: payload?.data },
      };
    });

    builder.addCase(getallairports.fulfilled, (state, { payload }) => {
      // axios response: the list lives at res.data.data. Error responses also
      // land here (thunk returns err.response), so never store a non-array.
      const list = payload?.data?.data;
      return { ...state, loading: false, allairports: Array.isArray(list) ? list : [] };
    });
    builder.addCase(getallairports.rejected, (state) => {
      return { ...state, loading: false, allairports: [] };
    });
    builder.addCase(getOriginAirports.fulfilled, (state, { payload }) => {
      return { ...state, loading: false, originairports: payload?.data?.data ?? [] };
    });
    builder.addCase(getOriginAirports.rejected, (state) => {
      return { ...state, loading: false, originairports: [] };
    });
    builder.addCase(getallshipments.fulfilled, (state, { payload }) => {
      return { ...state, loading: false, allshipports: payload?.data?.data };
    });
    builder.addCase(getCurrencyList.fulfilled, (state, { payload }) => {
      const list = Array.isArray(payload?.data?.data)
        ? payload.data.data
        : Array.isArray(payload?.data)
        ? payload.data
        : [];
      return { ...state, loading: false, currencyList: list };
    });
    builder.addCase(getPlatformList.fulfilled, (state, { payload }) => {
      const list = Array.isArray(payload?.data?.data)
        ? payload.data.data
        : Array.isArray(payload?.data)
        ? payload.data
        : [];
      return { ...state, loading: false, platformList: list };
    });
    builder.addCase(getOnlineList.fulfilled, (state, { payload }) => {
      const list = Array.isArray(payload?.data?.data)
        ? payload.data.data
        : Array.isArray(payload?.data)
        ? payload.data
        : [];
      return { ...state, loading: false, onlineList: list };
    });
    builder.addCase(getAllowedShippingLines.fulfilled, (state, { payload }) => {
      // Error responses also land here (thunk returns err.response).
      const list = payload?.data?.data;
      return { ...state, allowedShippingLines: Array.isArray(list) ? list : [] };
    });
    builder.addCase(viewBreakUp.pending, (state, { payload }) => {
      return { ...state, loading: true };
    })
    .addCase(viewBreakUp.fulfilled, (state, { payload }) => {
      // Bug fix: was writing to `allshipports` (the ocean port list), which
      // clobbered it with break-up data. Corrected to `viewBreakUp`.
      return { ...state, loading: false, viewBreakUp: payload };
    }).addCase(viewBreakUp.rejected, (state, { payload }) => {
      return { ...state, loading: false, viewBreakUp: payload };
    }).addCase(getOptionalVas.pending, (state, { payload }) => {
      return { ...state, loading: true };
    })
    .addCase(getOptionalVas.fulfilled, (state, { payload }) => {
      return { ...state, loading: false, optionalvas: payload };
    }).addCase(getOptionalVas.rejected,(state, {payload})=>{
      return { ...state, loading: false, optionalvas: payload };
    })
  },
});

export const { clearstate ,searchRateAnimation ,setsearchratesAvailableData ,clearSearchRateAvailableData, resetSearchRatesState, setOceanEditQuery, clearOceanSearchForm, setOceanEditLock} = searchRatesSlice.actions;
export const searchratestate = (state) => state.searchrates;
export default searchRatesSlice.reducer;
